unit TypeType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TTypeType = class
  private
    fTypeKey: String;
    fName: String;
    fType: String;
    fActive: Boolean;
  public
    property TypeKey: String read fTypeKey;
    property Name: String read fName;
    property TypeType: String read fType;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTypeType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fTypeKey := String(JSObject_Type['typeType']);
    fName := String(JSObject_Type['name']);
    fType := String(JSObject_Type['type']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
